import React, { Component } from "react";
import { Redirect } from "react-router";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";

class ImputSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  /*=============================================
	  =            Handle Togle User Block         =
	  =============================================*/

  /*=============================================
	=            Handle LogOut Function           =
	=============================================*/

  handeInputData = (selected) => (event) => {
    this.setState({ searchValue: event.target.value });
  };

  render() {
    let { redirect, searchValue } = this.state;
    if (redirect) return <Redirect to="/login" />;
    let acction;
    if (searchValue === "" || searchValue === undefined) {
    } else {
      acction = (
        <Link to={`/search/${encodeURIComponent(searchValue)}`}>
          <button className="d-none" type="submit">
            Submit
          </button>
        </Link>
      );
    }

    return (
      <form className="navbar-form">
        <div className="form-group">
          <input
            className="form-control"
            type="text"
            onChange={this.handeInputData()}
            placeholder="Search by: Shipment No, Customer, Containers, Status, Supplier, Consignee, From, To..."
          />
          <div
            className="tipodeletra main-close-especial fa fa-times navbar-form-close" /* onClick={()=> this.navigateToExactPath()} */
          ></div>
        </div>
        {acction}
      </form>
    );
  }
}
export default withRouter(ImputSearch);
